
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const Home = lazy(() => import('../pages/home/page'));
const Splash = lazy(() => import('../pages/splash/page'));
const MyCourses = lazy(() => import('../pages/my-courses/page'));
const CourseDetail = lazy(() => import('../pages/course-detail/page'));
const CoursePlayer = lazy(() => import('../pages/course-player/page'));
const Payment = lazy(() => import('../pages/payment/page'));
const Certificates = lazy(() => import('../pages/certificates/page'));
const Profile = lazy(() => import('../pages/profile/page'));
const Courses = lazy(() => import('../pages/courses/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Splash />
  },
  {
    path: '/home',
    element: <Home />
  },
  {
    path: '/courses',
    element: <Courses />
  },
  {
    path: '/my-courses',
    element: <MyCourses />
  },
  {
    path: '/course-detail/:id',
    element: <CourseDetail />
  },
  {
    path: '/course/:id',
    element: <CourseDetail />
  },
  {
    path: '/course-player/:id',
    element: <CoursePlayer />
  },
  {
    path: '/payment',
    element: <Payment />
  },
  {
    path: '/payment/:id',
    element: <Payment />
  },
  {
    path: '/certificates',
    element: <Certificates />
  },
  {
    path: '/profile',
    element: <Profile />
  },
  {
    path: '*',
    element: <NotFound />
  }
];

export default routes;
